import { useContactSettings } from '../hooks/useContactSettings'

export function LocationMap() {
  const { settings } = useContactSettings()

  return (
    <iframe
      className="location-map"
      height="420"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      src={settings.mapIframeUrl}
      title="Modi Cafe konum"
      width="1180"
    />
  )
}
